import React from 'react';
import '../template-file-css/document-file-template.css';


export const ROC_DiagnosticAssessment = ({ itemsRef, showErrorFor }) => {

    return (<form id='ROC_DiagnosticAssessment' className='file-pdf-document'>
        <div className='file-template'>

            <table>
                <tr>
                    <td className='w-750'><span className='eleHeader'>Primary Language:</span></td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" name="chkPrimaryLanguage" className='add-only' value="English" /> English
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkPrimaryLanguage" className='add-only' value="Sign Language" /> Sign Language
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkPrimaryLanguage" className='add-only' value="French" /> French
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" name="chkPrimaryLanguage" className='add-only' value="Spanish" /> Spanish
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkPrimaryLanguage" className='add-only' value="Other" /> Other
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkPrimaryLanguage" className='add-only' value="None" /> None
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" name="chkPrimaryLanguage" className='add-only' value="Unknown" /> Unknown
                    </td>
                </tr>

            </table>
            <div className='w-750'>
                <span className='eleHeader'>Consumer Residence:</span>

            </div>

            <table>

                <tr>
                    <td className='w-250'>
                        <input type="checkbox" name="chkConsumerResidence" className='add-only' value="Private Residence (Alone)" /> Private Residence (Alone)
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkConsumerResidence" className='add-only' value="Private Residence (with Others)" /> Private Residence (with Others)
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkConsumerResidence" className='add-only' value="Other Independent" /> Other Independent
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" name="chkConsumerResidence" className='add-only' value="Homeless" /> Homeless
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkConsumerResidence" className='add-only' value="Correctional Facility" /> Correctional Facility
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkConsumerResidence" className='add-only' value="Institution" /> Institution
                    </td>

                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" name="chkConsumerResidence" className='add-only' value="Residential Facility (Not Nursing)" /> Residential Facility (Not Nursing)
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkConsumerResidence" className='add-only' value="Foster Family/AFL" /> Foster Family/AFL
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkConsumerResidence" className='add-only' value="Nursing Home (ICF, SNF)" /> Nursing Home (ICF, SNF)
                    </td>

                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" name="chkConsumerResidence" className='add-only' value="Adult Care home (>= 7 beds)" /> Adult Care home (&#62;= 7 beds)
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkConsumerResidence" className='add-only' value="Adult Care home (<= 6 beds)" /> Adult Care home (&#60;= 6 beds)
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkConsumerResidence" className='add-only' value="Community IFC-MR (<=69 beds)" /> Community IFC-MR (&#60;=69 beds)
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" name="chkConsumerResidence" className='add-only' value="Community IFC-MR (>=70 beds)" /> Community IFC-MR (&#62;=70 beds)
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" name="chkConsumerResidence" className='add-only' value="Other" /> Other
                    </td>
                    <td className='w-250'>&nbsp;</td>
                </tr>
            </table>

            <h3>Evaluation Process</h3>
            <p className='w-750'>
                <span className='eleHeader'>Collateral Persons Involved in Assessment:</span>
                <textarea id="txtCollateralInvolved" name="txtCollateralInvolved" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Collateral Information Used:</span>
                <span className='small'>(ex: records, etc)</span>
                <textarea id="txtCollateralInformation" name="txtCollateralInformation" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Is Child Protective Services Currently Involved:</span>

                <input type='radio' id='rbChildProtectiveServices_NotApplicable' name='rbChildProtectiveServices' className='add-only' value='NotApplicable' checked /> Not Applicable &nbsp;
                <input type='radio' id='rbChildProtectiveServices_Yes' name='rbChildProtectiveServices' className='add-only' value='Yes' /> Yes &nbsp;
                <input type='radio' id='rbChildProtectiveServices_No' name='rbChildProtectiveServices' className='add-only' value='No' /> No
            </p>
            <p className='w-750'>
                <span className='eleHeader'>CPS Worker Name:</span>
                <input type='text' id='txtCpsWorkerName' name='txtCpsWorkerName' className='add-only' />
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Case Information:</span>
                <textarea id='txtCaseInormation' name='txtCaseInormation' className='add-only'></textarea>
            </p>
            <h3>Reasons for Seeking Services</h3>
            <p className='w-750'>
                <span className='eleHeader'>Presenting Problems:</span>
                <textarea id="txtPresentingProblems" name="txtPresentingProblems" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Other Sources of Distress:</span>
                <textarea id="txtOtherDistressSources" name="txtOtherDistressSources" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Precipitating Events:</span> <span className='small'>Why seeking services NOW?</span>
                <textarea id="txtPrecipitatingEvents" name="txtPrecipitatingEvents" className='add-only'></textarea>
            </p>
            <h3>General Health History</h3>
            <table>
                <tr>
                    <td className='w-375'><span className='eleHeader'>Primary Care Physician Name:</span></td>
                    <td className='w-375'><span className='eleHeader'>Are immunizations Current?</span></td>
                </tr>
                <tr>
                    <td className='w-375'> <input type='text' id='txtPrimaryPhysicianName' name='txtPrimaryPhysicianName' className='add-only' /> </td>
                    <td className='w-375'>
                        <input type='radio' id='rbImmunizations_Yes' name='rbImmunizations' className='add-only form-control-radio' value='Yes' /> Yes &nbsp;
                        <input type='radio' id='rbImmunizations_No' name='rbImmunizations' className='add-only' value='No' /> No
                    </td>
                </tr>
            </table>
            <p className='w-750'>
                <span className='eleHeader'>Problems and Symptoms:</span>
                <textarea id="txtProblemsSymptoms" name="txtProblemsSymptoms" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Treatment:</span>
                <textarea id="txtTreatment" name="txtTreatment" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Response to Treatment:</span>
                <textarea id="txtTreatmentResponse" name="txtTreatmentResponse" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Attitudes about Treatment</span>
                <textarea id="txtTreatmentAttitudes" name="txtTreatmentAttitudes" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Factors contributing or inhibiting previous recovery:</span>
                <textarea id="txtPreviousRecovery" name="txtPreviousRecovery" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Known allergies and adverse medication reactions:</span>
                <textarea id="txtAllergies" name="txtAllergies" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Has the client ever had tuberculosis?
                </span>
                <select id="ddlTB" name="ddlTB" className='add-only'>
                    <option value="1">Yes</option>
                    <option value="2">No</option>
                    <option value="3">Unknown</option>
                </select>
            </p>
            <h3>Education </h3>
            <table>
                <tr>
                    <td className='w-375'><span className='eleHeader'>Current School:</span></td>
                    <td className='w-375'><span className='eleHeader'>Current Grade Level:</span></td>
                </tr>
                <tr>
                    <td className='w-375'> <input type='text' id='txtCurrentSchool' name='txtCurrentSchool' className='add-only' /> </td>
                    <td className='w-375'> <input type='text' id='txtCurrentGradeLevel' name='txtCurrentGradeLevel' className='add-only' /> </td>
                </tr>
            </table>
            <p className='w-750'>
                <span className='eleHeader'>Does consumer have IEP/504?</span>
                <input type='radio' id='rbConsumerHaveIep_Na' name='rbConsumerHaveIep' className='add-only' value='Na' /> N/A &nbsp;
                <input type='radio' id='rbConsumerHaveIep_Yes' name='rbConsumerHaveIep' className='add-only' value='Yes' /> Yes &nbsp;
                <input type='radio' id='rbConsumerHaveIep_No' name='rbConsumerHaveIep' className='add-only' value='No' /> No
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Additional Information</span>

                <textarea id='txtAdditionalInformation' name='txtAdditionalInformation' className='add-only'></textarea>
            </p>
            <div>
                <h3>Mental Health Treatment History</h3>
                <table>
                    <tr>
                        <td className='w-750'><b>Outpatient</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Outcome:</span>
                            <select id="ddlOutpatientOutcome" name="ddlOutpatientOutcome" className='add-only'>
                                <option value="1">Unknown</option>
                                <option value="2">Improved</option>
                                <option value="3">No Change</option>
                                <option value="4">Worse</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Treatment Compliance (non-med):</span>
                            <select id="ddlOutpatientCompliance" name="ddlOutpatientCompliance" className='add-only'>
                                <option value="1">Unknown</option>
                                <option value="2">Poor</option>
                                <option value="3">Fair</option>
                                <option value="4">Good</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}><b>IOP/Partial</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Outcome:</span>
                            <select id="ddlIopOutcome" name="ddlIopOutcome" className='add-only'>
                                <option value="1">Unknown</option>
                                <option value="2">Improved</option>
                                <option value="3">No Change</option>
                                <option value="4">Worse</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Treatment Compliance (non-med):</span>
                            <select id="ddlIopCompliance" name="ddlIopCompliance" className='add-only'>
                                <option value="1">Unknown</option>
                                <option value="2">Poor</option>
                                <option value="3">Fair</option>
                                <option value="4">Good</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}><b>Inpatient/Residential</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Outcome:</span>
                            <select id="ddlInpatientOutcome" name="ddlInpatientOutcome" className='add-only'>
                                <option value="1">Unknown</option>
                                <option value="2">Improved</option>
                                <option value="3">No Change</option>
                                <option value="4">Worse</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Treatment Compliance (non-med):</span>
                            <select id="ddlInpatientCompliance" name="ddlInpatientCompliance" className='add-only'>
                                <option value="1">Unknown</option>
                                <option value="2">Poor</option>
                                <option value="3">Fair</option>
                                <option value="4">Good</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}><b>Number of psychiatric hospitalizations:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>In the past 12 months</span>
                            <input type='text' id="txtPsychHospitalRecent" name="txtPsychHospitalRecent" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>In lifetime</span>
                            <input type='text' id="txtPsychHospitalLife" name="txtPsychHospitalLife" className='add-only' />
                        </td>
                    </tr>
                </table>
            </div>
            <p className='w-750'>
                <span className='eleHeader'>Additional MH Treatment History/Information:</span>
                <textarea id="txtAdditionalMhInfo" name="txtAdditionalMhInfo" className='add-only'></textarea>
            </p>

            <p className='w-750'>
                <b>
                    <center>
                        Current Psychotropic Medications </center></b>

            </p>

            <table>
                <tr>
                    <td className='w-450'><span className='eleHeader'>Medication Name </span></td>
                    <td className='w-100'><span className='eleHeader'> Dose </span></td>
                    <td className='w-100'><span className='eleHeader'> Frequency </span></td>
                    <td className='w-100'><span className='eleHeader'> Usually Adherent? </span></td>
                </tr>
                <tr>
                    <td className='w-450'>
                        <input type='text' id="txtMedicationName" name="txtMedicationName" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <input type='text' id="txtMedicationDose" name="txtMedicationDose" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <input type='text' id="txtMedicationFrequency" name="txtMedicationFrequency" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <select id="ddlUsuallyAdherent" name="ddlUsuallyAdherent" className='add-only'>
                            <option value="1">Yes</option>
                            <option value="2">No</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td className='w-450'>
                        <input type='text' id="txtMedicationName1" name="txtMedicationName1" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <input type='text' id="txtMedicationDose1" name="txtMedicationDose1" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <input type='text' id="txtMedicationFrequency1" name="txtMedicationFrequency1" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <select id="ddlUsuallyAdherent1" name="ddlUsuallyAdherent1" className='add-only'>
                            <option value="1">Yes</option>
                            <option value="2">No</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td className='w-450'>
                        <input type='text' id="txtMedicationName2" name="txtMedicationName2" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <input type='text' id="txtMedicationDose2" name="txtMedicationDose2" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <input type='text' id="txtMedicationFrequency2" name="txtMedicationFrequency2" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <select id="ddlUsuallyAdherent2" name="ddlUsuallyAdherent2" className='add-only'>
                            <option value="1">Yes</option>
                            <option value="2">No</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td className='w-450'>
                        <input type='text' id="txtMedicationName3" name="txtMedicationName3" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <input type='text' id="txtMedicationDose3" name="txtMedicationDose3" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <input type='text' id="txtMedicationFrequency3" name="txtMedicationFrequency3" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <select id="ddlUsuallyAdherent3" name="ddlUsuallyAdherent3" className='add-only'>
                            <option value="1">Yes</option>
                            <option value="2">No</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td className='w-450'>
                        <input type='text' id="txtMedicationName4" name="txtMedicationName4" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <input type='text' id="txtMedicationDose4" name="txtMedicationDose4" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <input type='text' id="txtMedicationFrequency4" name="txtMedicationFrequency4" className='add-only' />
                    </td>
                    <td className='w-100'>
                        <select id="ddlUsuallyAdherent4" name="ddlUsuallyAdherent4" className='add-only'>
                            <option value="1">Yes</option>
                            <option value="2">No</option>
                        </select>
                    </td>
                </tr>
            </table>

            <p className='w-750'>
                <span className='eleHeader'>Medication History:</span>
                <textarea id="txtMedicationHistory" name="txtMedicationHistory" className='add-only'></textarea>
            </p>

            <div>
                <h3>Diagnostic Impression</h3>
                <h4>DSM-5</h4>
                <table>
                    <tr>
                        <td className='w-30'><span className='eleHeader'>#</span></td>
                        <td className='w-500'><span className='eleHeader'>Diagnosis</span></td>
                        <td className='w-220'><span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-30'>(1)</td>
                        <td className='w-500'>
                            <input type='text' id="txtDSM5Dx_1" name="txtDSM5Dx_1" className='add-only' /></td>
                        <td className='w-220'>
                            <input id="txtDSM5Date_1" type='date' name="txtDSM5Date_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-30'>(2)</td>
                        <td className='w-500'>
                            <input type='text' id="txtDSM5Dx_2" name="txtDSM5Dx_2" className='add-only' /></td>
                        <td className='w-220'>
                            <input id="txtDSM5Date_2" type='date' name="txtDSM5Date_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-30'>(3)</td>
                        <td className='w-500'>
                            <input type='text' id="txtDSM5Dx_3" name="txtDSM5Dx_3" className='add-only' /></td>
                        <td className='w-220'>
                            <input id="txtDSM5Date_3" type='date' name="txtDSM5Date_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-30'>(4)</td>
                        <td className='w-500'>
                            <input type='text' id="txtDSM5Dx_4" name="txtDSM5Dx_4" className='add-only' /></td>
                        <td className='w-220'>
                            <input id="txtDSM5Date_4" type='date' name="txtDSM5Date_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-30'>(5)</td>
                        <td className='w-500'>
                            <input type='text' id="txtDSM5Dx_5" name="txtDSM5Dx_5" className='add-only' /></td>
                        <td className='w-220'>
                            <input id="txtDSM5Date_5" type='date' name="txtDSM5Date_5" className='add-only' /></td>
                    </tr>
                </table>
            </div>
            <div>
                <h3>Substance Abuse Treatment History</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Client Denies Any Substance Abuse:</span>

                    <input type='radio' id='rbSubstanceAbuse_Yes' name='rbSubstanceAbuse' className='add-only' value='Yes' checked /> Yes &nbsp;
                    <input type='radio' id='rbSubstanceAbuse_No' name='rbSubstanceAbuse' className='add-only' value='No' /> No
                </p>
                <table>
                    <tr>
                        <td colSpan={2}><b>Outpatient</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Outcome:</span>
                            <select id="ddlSubstanceOutpatientOutcome" name="ddlSubstanceOutpatientOutcome" className='add-only'>
                                <option value="0">N/A</option>
                                <option value="1">Unknown</option>
                                <option value="2">Improved</option>
                                <option value="3">No Change</option>
                                <option value="4">Worse</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Treatment Compliance (non-med):</span>
                            <select id="ddlSubstanceOutpatientCompliance" name="ddlSubstanceOutpatientCompliance" className='add-only'>
                                <option value="0">N/A</option>
                                <option value="1">Unknown</option>
                                <option value="2">Poor</option>
                                <option value="3">Fair</option>
                                <option value="4">Good</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}><b>IOP/Partial</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Outcome:</span>
                            <select id="ddlSubstanceIOPOutcome" name="ddlSubstanceIOPOutcome" className='add-only'>
                                <option value="0">N/A</option>
                                <option value="1">Unknown</option>
                                <option value="2">Improved</option>
                                <option value="3">No Change</option>
                                <option value="4">Worse</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Treatment Compliance (non-med):</span>
                            <select id="ddlSubstanceIOPTreatment" name="ddlSubstanceIOPTreatment" className='add-only'>
                                <option value="0">N/A</option>
                                <option value="1">Unknown</option>
                                <option value="2">Poor</option>
                                <option value="3">Fair</option>
                                <option value="4">Good</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}><b>Inpatient/Residential</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Outcome:</span>
                            <select id="ddlSubstanceInpatientOutcome" name="ddlSubstanceInpatientOutcome" className='add-only'>
                                <option value="0">N/A</option>
                                <option value="1">Unknown</option>
                                <option value="2">Improved</option>
                                <option value="3">No Change</option>
                                <option value="4">Worse</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Treatment Compliance (non-med):</span>
                            <select id="ddlSubstanceInpatientTreatment" name="ddlSubstanceInpatientTreatment" className='add-only'>
                                <option value="0">N/A</option>
                                <option value="1">Unknown</option>
                                <option value="2">Poor</option>
                                <option value="3">Fair</option>
                                <option value="4">Good</option>
                            </select>
                        </td>
                    </tr>
                </table>
            </div>
            <div>
                <h3>Alcohol &amp; Drug Use</h3>
                <p className='w-750'>
                    <select id="ddlCurrentUse" name="ddlCurrentUse" className='add-only'>
                        <option value="1">No current/recent use of alcohol or other drugs</option>
                        <option value="2">Current/recent use of alcohol or other drugs within normal limits</option>
                    </select>
                </p>
            </div>
            <p className='w-750'>
                <span className='eleHeader'>Comments:</span>
                <textarea id="txtCurrentUseComments" name="txtCurrentUseComments" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Current/Recent Abuse Indicators:</span>
                <select id="ddlAbuseIndicators" name="ddlAbuseIndicators" className='add-only'>
                    <option value="5">N/A</option>
                    <option value="1">Recurrent use resulting in major role failure</option>
                    <option value="2">Recurrent use in situations in which it is physically hazardous</option>
                    <option value="3">Recurrent substance-related legal problems</option>
                    <option value="4">Continued use despite causing persistent or recurrent social or interpersonal problems</option>
                </select>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Current/Recent Dependence Indicators:</span>
                <select id="ddlDependenceIndicators" name="ddlDependenceIndicators" className='add-only'>
                    <option value="8">N/A</option>
                    <option value="1">Tolerance</option>
                    <option value="2">Withdrawal</option>
                    <option value="3">Substance taken in larger amounts or over longer time than intended</option>
                    <option value="4">Persistent desire or unsuccessful efforts to cut down or control substance use</option>
                    <option value="5">Great deal of time spent in activities necessary to obtain substance</option>
                    <option value="6">Important social, occupational, or recreational activities given up
                        or reduced because of substance abuse</option>
                    <option value="7">Use continued despite knowledge of having persistent/recurrent physical
                        or psychological problem</option>
                </select>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>SA Diagnostic Tool(s) used:</span>
                <textarea id="txtSADiagnosticTools" name="txtSADiagnosticTools" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Assessment Results:</span>
                <textarea id="txtAssessmentResults" name="txtAssessmentResults" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>N.C. Modified A/ASAM Placement Level:</span>
                <textarea id="txtAASAMPlacementLevel" name="txtAASAMPlacementLevel" className='add-only'></textarea>
            </p>
            <h3>Functional Domains:</h3>
            <p className='w-750'>
                <span className='eleHeader'> Nutrition/Eating:</span>
                <input type='checkbox' id='rbFunctionalDomainsNone_1' name='rbFunctionalDomainsNone_1' className='add-only' value='NoneReported ' /> None Reported
                <input type='text' id='txtFunctionalDomains_1' name='txtFunctionalDomains_1' className='add-only' />
            </p>
            <p className='w-750'>
                <span className='eleHeader'> Pain Management/Health:</span>
                <input type='checkbox' id='rbFunctionalDomainsNone_2' name='rbFunctionalDomainsNone_2' className='add-only' value='NoneReported ' /> None Reported
                <input type='text' id='txtFunctionalDomains_2' name='txtFunctionalDomains_2' className='add-only' />
            </p>
            <p className='w-750'>
                <span className='eleHeader'> Depressed/sad mood:</span>
                <input type='checkbox' id='rbFunctionalDomainsNone_3' name='rbFunctionalDomainsNone_3' className='add-only' value='NoneReported ' /> None Reported
                <input type='text' id='txtFunctionalDomains_3' name='txtFunctionalDomains_3' className='add-only' />

            </p>
            <p className='w-750'>
                <span className='eleHeader'> Bereavement Issues:</span>
                <input type='checkbox' id='rbFunctionalDomainsNone_4' name='rbFunctionalDomainsNone_4' className='add-only' value='NoneReported ' /> None Reported
                <input type='text' id='txtFunctionalDomains_4' name='txtFunctionalDomains_4' className='add-only' />

            </p>
            <p className='w-750'>
                <span className='eleHeader'> Anxiety:</span>

                <input type='checkbox' id='rbFunctionalDomainsNone_5' name='rbFunctionalDomainsNone_5' className='add-only' value='NoneReported ' /> None Reported
                <input type='text' id='txtFunctionalDomains_5' name='txtFunctionalDomains_5' className='add-only' />

            </p>
            <p className='w-750'>
                <span className='eleHeader'> Anger/Aggression:</span>
                <input type='checkbox' id='rbFunctionalDomainsNone_6' name='rbFunctionalDomainsNone_6' className='add-only' value='NoneReported ' /> None Reported
                <input type='text' id='txtFunctionalDomains_6' name='txtFunctionalDomains_6' className='add-only' />

            </p>
            <p className='w-750'>
                <span className='eleHeader'> Oppositional:</span>
                <input type='checkbox' id='rbFunctionalDomainsNone_7' name='rbFunctionalDomainsNone_7' className='add-only' value='NoneReported ' /> None Reported
                <input type='text' id='txtFunctionalDomains_7' name='txtFunctionalDomains_7' className='add-only' />

            </p>
            <p className='w-750'>
                <span className='eleHeader'> Inattention/Organized:</span>
                <input type='checkbox' id='rbFunctionalDomainsNone_8' name='rbFunctionalDomainsNone_8' className='add-only' value='NoneReported ' /> None Reported
                <input type='text' id='txtFunctionalDomains_8' name='txtFunctionalDomains_8' className='add-only' />

            </p>
            <p className='w-750'>
                <span className='eleHeader'> Impulsivity:</span>
                <input type='checkbox' id='rbFunctionalDomainsNone_9' name='rbFunctionalDomainsNone_9' className='add-only' value='NoneReported ' /> None Reported
                <input type='text' id='txtFunctionalDomains_9' name='txtFunctionalDomains_9' className='add-only' />

            </p>
            <p className='w-750'>
                <span className='eleHeader'> Disturbed Realty Contact (psychosis):</span>
                <input type='checkbox' id='rbFunctionalDomainsNone_10' name='rbFunctionalDomainsNone_10' className='add-only' value='NoneReported ' /> None Reported
                <input type='text' id='txtFunctionalDomains_10' name='txtFunctionalDomains_10' className='add-only' />

            </p>
            <p className='w-750'>
                <span className='eleHeader'> Mood Swings/Hyperactivity:</span>
                <input type='checkbox' id='rbFunctionalDomainsNone_11' name='rbFunctionalDomainsNone_11' className='add-only' value='NoneReported ' /> None Reported
                <input type='text' id='txtFunctionalDomains_11' name='txtFunctionalDomains_11' className='add-only' />

            </p>
            <p className='w-750'>
                <span className='eleHeader'> Compulsions/Rituals:</span>
                <input type='checkbox' id='rbFunctionalDomainsNone_12' name='rbFunctionalDomainsNone_12' className='add-only' value='NoneReported ' /> None Reported
                <input type='text' id='txtFunctionalDomains_12' name='txtFunctionalDomains_12' className='add-only' />

            </p>
            <p className='w-750'>
                <span className='eleHeader'> Sleeping:</span>
                <input type='checkbox' id='rbFunctionalDomainsNone_13' name='rbFunctionalDomainsNone_13' className='add-only' value='NoneReported ' /> None Reported
                <input type='text' id='txtFunctionalDomains_13' name='txtFunctionalDomains_13' className='add-only' />

            </p>
            <p className='w-750'>
                <span className='eleHeader'> Psychosocial:</span>
                <input type='checkbox' id='rbFunctionalDomainsNone_14' name='rbFunctionalDomainsNone_14' className='add-only' value='NoneReported ' /> None Reported
                <input type='text' id='txtFunctionalDomains_14' name='txtFunctionalDomains_14' className='add-only' />

            </p>

            <h3>Consumer's Supports</h3>
            <p className='w-750'>
                Ability to Care for Self:
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Self care deficits or problems:</span>
                <textarea id="txtSelfCareDeficits" name="txtSelfCareDeficits" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Primary Support Group:</span>
                <textarea id="txtPrimarySupportGroup" name="txtPrimarySupportGroup" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Friendships and Social Supports:</span>
                <textarea id="txtSocialSupports" name="txtSocialSupports" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>History of Abuse or Neglect:</span>
                <textarea id="txtHistoryOfAbuse" name="txtHistoryOfAbuse" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Relevant Family History:</span>
                <textarea id="txtFamilyHistory" name="txtFamilyHistory" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Consumer's Religious Preferences:</span>
                <textarea id="txtConsumerReligiousPreferences" name="txtConsumerReligiousPreferences" className='add-only'></textarea>
            </p>
            <h3>Employment</h3>
            <p className='w-750'>
                <span className='eleHeader'>Employment Status:</span>
                <select id="ddlEmploymentStatus" name="ddlEmploymentStatus" className='add-only'>
                    <option value="10">Unknown</option>
                    <option value="1">Unemployed, available for work</option>
                    <option value="2">Employed, full-time</option>
                    <option value="3">Employed, part-time, &#60; 35 hrs/week</option>
                    <option value="4">Not in work force - Student</option>
                    <option value="5">Not in work force - Retired</option>
                    <option value="6">Not in work force - Homemaker</option>
                    <option value="7">Not in work force - Not available for work</option>
                    <option value="8">Armed Forces/National Guard (excl. Reserves)</option>
                    <option value="9">Seasonal/Migrant Worker</option>
                </select>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Employment Strengths/Challenges:</span>
                <textarea id="txtEmploymentStrengths" name="txtEmploymentStrengths" className='add-only'></textarea>
            </p>
            <div>
                <h3>Consumer's Strengths & Limitations</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Describe consumer's strengths and limitations:</span>
                    <span className='small'>(In areas that affect treatment, including housing, financial,
                        access to health care, legal, co-morbidity, recovery environment, and treatment
                        and recovery history.)</span>
                    <textarea id="txtConsumerStrengths" name="txtConsumerStrengths" className='add-only'></textarea>
                </p>
            </div>
            <p className='w-750'>
                Other Assessment Information &amp; Data:<br />
                <textarea id="txtOtherAssessmentInfo" name="txtOtherAssessmentInfo" className='add-only'></textarea>
            </p>
            <h3>Current Impairments</h3>
            <span className='small'>Scale: 0 = None, 1 = Mild, 2 = Moderate, 3 = Severe, N/A = Not Assessed</span>
            <table>
                <tr>
                    <td className='w-375'>
                        <span className='eleHeader'>Mood Disturbance (Depression or mania)</span>

                        <select id="ddlImpairmentsMood" name="ddlImpairmentsMood" className='add-only'>
                            <option value="0">0 = None</option>
                            <option value="1">1 = Mild</option>
                            <option value="2">2 = Moderate</option>
                            <option value="3">3 = Severe</option>
                            <option value="4">N/A = Not Assessed</option>
                        </select>
                    </td>
                    <td className='w-375'>
                        <span className='eleHeader'>Anxiety</span>

                        <select id="ddlImpairmentsAnxiety" name="ddlImpairmentsAnxiety" className='add-only'>
                            <option value="0">0 = None</option>
                            <option value="1">1 = Mild</option>
                            <option value="2">2 = Moderate</option>
                            <option value="3">3 = Severe</option>
                            <option value="4">N/A = Not Assessed</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <span className='eleHeader'>Psychosis</span>
                        <select id="ddlImpairmentsPsychosis" name="ddlImpairmentsPsychosis" className='add-only'>
                            <option value="0">0 = None</option>
                            <option value="1">1 = Mild</option>
                            <option value="2">2 = Moderate</option>
                            <option value="3">3 = Severe</option>
                            <option value="4">N/A = Not Assessed</option>
                        </select>

                    </td>
                    <td className='w-375'>
                        <span className='eleHeader'> Thinking/Cognition/Memory</span>
                        <select id="ddlImpairmentsThinking" name="ddlImpairmentsThinking" className='add-only'>
                            <option value="0">0 = None</option>
                            <option value="1">1 = Mild</option>
                            <option value="2">2 = Moderate</option>
                            <option value="3">3 = Severe</option>
                            <option value="4">N/A = Not Assessed</option>
                        </select>

                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <span className='eleHeader'>Impulsive/Reckless Aggressive</span>
                        <select id="ddlImpairmentsAggressive" name="ddlImpairmentsAggressive" className='add-only'>
                            <option value="0">0 = None</option>
                            <option value="1">1 = Mild</option>
                            <option value="2">2 = Moderate</option>
                            <option value="3">3 = Severe</option>
                            <option value="4">N/A = Not Assessed</option>
                        </select>

                    </td>
                    <td className='w-375'>
                        <span className='eleHeader'>Activities of Daily Living</span>
                        <select id="ddlImpairmentsDailyLiving" name="ddlImpairmentsDailyLiving" className='add-only'>
                            <option value="0">0 = None</option>
                            <option value="1">1 = Mild</option>
                            <option value="2">2 = Moderate</option>
                            <option value="3">3 = Severe</option>
                            <option value="4">N/A = Not Assessed</option>
                        </select>

                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <span className='eleHeader'>Weight Loss Associated with Eating Disorder</span>
                        <select id="ddlImpairmentsWeightLoss" name="ddlImpairmentsWeightLoss" className='add-only'>
                            <option value="0">0 = None</option>
                            <option value="1">1 = Mild</option>
                            <option value="2">2 = Moderate</option>
                            <option value="3">3 = Severe</option>
                            <option value="4">N/A = Not Assessed</option>
                        </select>

                    </td>
                    <td className='w-375'>
                        <span className='eleHeader'>Medical/Physical Condition(s)</span>
                        <select id="ddlImpairmentsConditions" name="ddlImpairmentsConditions" className='add-only'>
                            <option value="0">0 = None</option>
                            <option value="1">1 = Mild</option>
                            <option value="2">2 = Moderate</option>
                            <option value="3">3 = Severe</option>
                            <option value="4">N/A = Not Assessed</option>
                        </select>

                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <span className='eleHeader'>Job/School Performance</span>
                        <select id="ddlImpairmentsPerformance" name="ddlImpairmentsPerformance" className='add-only'>
                            <option value="0">0 = None</option>
                            <option value="1">1 = Mild</option>
                            <option value="2">2 = Moderate</option>
                            <option value="3">3 = Severe</option>
                            <option value="4">N/A = Not Assessed</option>
                        </select>

                    </td>
                    <td className='w-375'>
                        <span className='eleHeader'>Social/Marital/Family Problems</span>
                        <select id="ddlImpairmentsProblems" name="ddlImpairmentsProblems" className='add-only'>
                            <option value="0">0 = None</option>
                            <option value="1">1 = Mild</option>
                            <option value="2">2 = Moderate</option>
                            <option value="3">3 = Severe</option>
                            <option value="4">N/A = Not Assessed</option>
                        </select>

                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <span className='eleHeader'>Legal</span>
                        <select id="ddlImpairmentsLegal" name="ddlImpairmentsLegal" className='add-only'>
                            <option value="0">0 = None</option>
                            <option value="1">1 = Mild</option>
                            <option value="2">2 = Moderate</option>
                            <option value="3">3 = Severe</option>
                            <option value="4">N/A = Not Assessed</option>
                        </select>

                    </td>
                    <td className='w-375'>&nbsp;
                    </td>
                </tr>
            </table>
            <p className='w-750'>
                <span className='eleHeader'>Assessment Interpretation &amp; Case Formulation:</span>
                <textarea id="txtAssessmentInterpretation" name="txtAssessmentInterpretation" className='add-only'></textarea>
            </p>
            <div>
                <h3>Consumer's Treatment/Recovery Goals</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Goals:</span>
                    <textarea id="txtRecoveryGoals" name="txtRecoveryGoals" className='add-only'></textarea>
                </p>
            </div>
            <h5>Goals &amp; Objectives</h5>
            <p className='w-750'>
                <span className='eleHeader'>Goal #1:</span>
                <textarea id="txtGoal_1" name="txtGoal_1" className='add-only' ></textarea>
            </p>
            <table>
                <tr>
                    <td className='w-375'>
                        <span className='eleHeader'>Outcome Measurement Tool:</span>
                        <input type='text' id="txtOutcomeMeasurementTool_1" name="txtOutcomeMeasurementTool_1" className='add-only' />
                    </td>
                    <td className='w-375'>
                        <span className='eleHeader'>Anticipate Date of Achievement:</span>
                        <input type='date' id="txtAnticipateDate_1" name="txtAnticipateDate_1" className='add-only' />

                    </td>
                </tr>
            </table>
            <p className='w-750'>
                <span className='eleHeader'>Objective #1:</span>
                <textarea id="txtObjective_1_1" name="txtObjective_1_1" className='add-only' rows={5}></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Intervention(s) for Objective #1:</span>
                <textarea id="txtInterventions_1_1" name="txtInterventions_1_1" className='add-only' rows={5}></textarea>
            </p>

            <p className='w-750'>
                <span className='eleHeader'>Consumer's Readiness &amp; Motivation to Engage in Treatment:</span>
                <textarea id="txtCustomersMotivation" name="txtCustomersMotivation" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Assessors' Treatment/Service Recommendations:</span>
                <textarea id="txtAssessorsRecommendations" name="txtAssessorsRecommendations" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Team Review Date:</span>
                <input type="date" id="rdpTeamReviewDate" name="rdpTeamReviewDate" className='add-only' />
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Participants:</span>
                <textarea id="txtParticipants" name="txtParticipants" className='add-only'></textarea>
            </p>
            <p className='w-750'>
                <span className='eleHeader'>Summary of Discussion and Recommendations:</span>
                <textarea id="txtSummaryRecommendations" name="txtSummaryRecommendations" className='add-only'></textarea>
            </p>

            <span className='eleHeader'>Mental Status Exam</span>
            <table border={0}>
                <tr>
                    <td colSpan={4}>
                        <span><strong>Orientation:</strong></span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbOrientation_1" name="cbOrientation_1" className='add-only' value="Person" /> Person
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbOrientation_2" name="cbOrientation_2" className='add-only' value="Place" /> Place
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbOrientation_3" name="cbOrientation_3" className='add-only' value="Time" /> Time
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbOrientation_4" name="cbOrientation_4" className='add-only' value="Situation" /> Situation
                    </td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <span><strong>Mood:</strong></span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbMood_1" name="cbMood_1" className='add-only' value="Euthymic" /> Euthymic
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbMood_2" name="cbMood_2" className='add-only' value="Anxious" /> Anxious
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbMood_3" name="cbMood_3" className='add-only' value="Angry" /> Angry
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbMood_4" name="cbMood_4" className='add-only' value="Irritable" /> Irritable
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbMood_5" name="cbMood_5" className='add-only' value="Depressed" /> Depressed
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbMood_6" name="cbMood_6" className='add-only' value="Sad" /> Sad
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbMood_7" name="cbMood_7" className='add-only' value="Elated" /> Elated
                    </td>
                    <td className='w-187'>&nbsp;</td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <span><strong>Affect:</strong></span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbAffect_1" name="cbAffect_1" className='add-only' value="Appropriate" /> Appropriate
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbAffect_2" name="cbAffect_2" className='add-only' value="Blunted" /> Blunted
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbAffect_3" name="cbAffect_3" className='add-only' value="Flat" /> Flat
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbAffect_4" name="cbAffect_4" className='add-only' value="Labile" /> Labile
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbAffect_5" name="cbAffect_5" className='add-only' value="Depressed" /> Depressed
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbAffect_6" name="cbAffect_6" className='add-only' value="Expansive" /> Expansive
                    </td>
                    <td className='w-187'>&nbsp;</td>
                    <td className='w-187'>&nbsp;</td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <span><strong>Speech:</strong></span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbSpeech_1" name="cbSpeech_1" className='add-only' value="Coherent" /> Coherent
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbSpeech_2" name="cbSpeech_2" className='add-only' value="Soft" /> Soft
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbSpeech_3" name="cbSpeech_3" className='add-only' value="Mute" /> Mute
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbSpeech_4" name="cbSpeech_4" className='add-only' value="Loud" /> Loud
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbSpeech_5" name="cbSpeech_5" className='add-only' value="Poverty" /> Poverty
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbSpeech_6" name="cbSpeech_6" className='add-only' value="Stullering" /> Stullering
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbSpeech_7" name="cbSpeech_7" className='add-only' value="Pressured" /> Pressured
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbSpeech_8" name="cbSpeech_8" className='add-only' value="Dysarthria" /> Dysarthria
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbSpeech_9" name="cbSpeech_9" className='add-only' value="Increased Latency" /> Increased Latency
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbSpeech_10" name="cbSpeech_10" className='add-only' value="Incoherent" /> Incoherent
                    </td>
                    <td className='w-187'>&nbsp;</td>
                    <td className='w-187'>&nbsp;</td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <span><strong>Attention/Concentration:</strong></span>
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" id="cbConcentration_3" name="cbConcentration_3" className='add-only' value="Spell World backwards" /> Spell "World" backwards
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbConcentration_4" name="cbConcentration_4" className='add-only' value="Name the months backwards" /> Name the months backwards
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbConcentration_5" name="cbConcentration_5" className='add-only' value="No Gross Cognitive Deficits" /> No Gross Cognitive Deficits
                    </td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <span><strong>Fund of Knowledge:</strong></span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbKnowledge_1" name="cbKnowledge_1" className='add-only' value="Good" /> Good
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbKnowledge_2" name="cbKnowledge_2" className='add-only' value="Fair" /> Fair
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbKnowledge_3" name="cbKnowledge_3" className='add-only' value="Poor" /> Poor
                    </td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <span><strong>Insight:</strong></span>
                    </td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <span>Understands illness:</span>
                        &nbsp;
                        <input type="radio" id="rbIllness_Yes" name="rbIllness" className='add-only' value="Yes" /> Yes
                        &nbsp;
                        <input type="radio" id="rbIllness_No" name="rbIllness" className='add-only' value="No" /> No
                    </td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <span><strong>Judgement:</strong></span>
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <span>"Makes good decisions" regarding illness:</span>
                        &nbsp;
                        <input type="radio" id="rbRegardingIllness_Yes" name="rbRegardingIllness" className='add-only' value="Yes" /> Yes
                        &nbsp;
                        <input type="radio" id="rbRegardingIllness_No" name="rbRegardingIllness" className='add-only' value="No" /> No
                        &nbsp;
                    </td>
                    <td className='w-375'>
                        <span>in life:</span>
                        &nbsp;
                        <input type="radio" id="rbLife_Yes" name="rbLife" className='add-only' value="Yes" /> Yes
                        &nbsp;
                        <input type="radio" id="rbLife_No" name="rbLife" className='add-only' value="No" /> No
                    </td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <span><strong>Thought Process:</strong></span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbThoughtProcess_1" name="cbThoughtProcess_1" className='add-only' value="Appropriate" /> Appropriate
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbThoughtProcess_2" name="cbThoughtProcess_2" className='add-only' value="Goal Directed" /> Goal Directed
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbThoughtProcess_3" name="cbThoughtProcess_3" className='add-only' value="Illogical" /> Illogical
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbThoughtProcess_4" name="cbThoughtProcess_4" className='add-only' value="Tangential" /> Tangential
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbThoughtProcess_5" name="cbThoughtProcess_5" className='add-only' value="Circumstantial" /> Circumstantial
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbThoughtProcess_6" name="cbThoughtProcess_6" className='add-only' value="Abstract" /> Abstract
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbThoughtProcess_7" name="cbThoughtProcess_7" className='add-only' value="Concrete" /> Concrete
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbThoughtProcess_8" name="cbThoughtProcess_8" className='add-only' value="Disorganized" /> Disorganized
                    </td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <span><strong>Abnormal/Psychotic Thoughts:</strong></span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_1" name="cbPsychoticThoughts_1" className='add-only' value="Hallucinations" /> Hallucinations
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_2" name="cbPsychoticThoughts_2" className='add-only' value="Delusional" /> Delusional
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_3" name="cbPsychoticThoughts_3" className='add-only' value="Persecution" /> Persecution
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_4" name="cbPsychoticThoughts_4" className='add-only' value="Reference" /> Reference
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_5" name="cbPsychoticThoughts_5" className='add-only' value="Thoughts Insertion" /> Thoughts Insertion
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_6" name="cbPsychoticThoughts_6" className='add-only' value="Broadcasting" /> Broadcasting
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_7" name="cbPsychoticThoughts_7" className='add-only' value="Phobias" /> Phobias
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_8" name="cbPsychoticThoughts_8" className='add-only' value="Grandiose" /> Grandiose
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_9" name="cbPsychoticThoughts_9" className='add-only' value="Guilt" /> Guilt
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_10" name="cbPsychoticThoughts_10" className='add-only' value="Clanging" /> Clanging
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_11" name="cbPsychoticThoughts_11" className='add-only' value="Compulsions" /> Compulsions
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_12" name="cbPsychoticThoughts_12" className='add-only' value="Suicidal Ideation" /> Suicidal Ideation
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_13" name="cbPsychoticThoughts_13" className='add-only' value="Suicidal Plan" /> Suicidal Plan
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_14" name="cbPsychoticThoughts_14" className='add-only' value="Loneliness" /> Loneliness
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_15" name="cbPsychoticThoughts_15" className='add-only' value="Perseveration" /> Perseveration
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_16" name="cbPsychoticThoughts_16" className='add-only' value="Obsessions" /> Obsessions
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_17" name="cbPsychoticThoughts_17" className='add-only' value="Word Salad" /> Word Salad
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_18" name="cbPsychoticThoughts_18" className='add-only' value="Worthlessness" /> Worthlessness
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_19" name="cbPsychoticThoughts_19" className='add-only' value="Loose Associations" /> Loose Associations
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_20" name="cbPsychoticThoughts_20" className='add-only' value="Flight of Ideas" />  Flight of Ideas
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_21" name="cbPsychoticThoughts_21" className='add-only' value="Hopelessness" /> Hopelessness
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_22" name="cbPsychoticThoughts_22" className='add-only' value="Homicidal Plan" /> Homicidal Plan
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_23" name="cbPsychoticThoughts_23" className='add-only' value="Homicidal Ideation" /> Homicidal Ideation
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbPsychoticThoughts_24" name="cbPsychoticThoughts_24" className='add-only' value="Self Deprecation" /> Self Deprecation
                    </td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <span><strong>Memory:</strong></span>
                    </td>
                </tr>
                <tr>
                    <td className='w-100'>
                        <span>Immediate</span>
                    </td>
                    <td className='w-100'>
                        <input type="checkbox" id="cbImmediate_1" name="cbImmediate_1" className='add-only' value="Good" /> Good
                    </td>
                    <td className='w-100'>
                        <input type="checkbox" id="cbImmediate_2" name="cbImmediate_2" className='add-only' value="Fair" /> Fair
                    </td>
                    <td className='w-450'>
                        <input type="checkbox" id="cbImmediate_3" name="cbImmediate_3" className='add-only' value="Impaired" /> Impaired
                    </td>
                </tr>
                <tr>
                    <td className='w-100'>
                        <span>Present</span>
                    </td>
                    <td className='w-100'>
                        <input type="checkbox" id="cbPresent_1" name="cbPresent_1" className='add-only' value="Good" /> Good
                    </td>
                    <td className='w-100'>
                        <input type="checkbox" id="cbPresent_2" name="cbPresent_2" className='add-only' value="Fair" /> Fair
                    </td>
                    <td className='w-450'>
                        <input type="checkbox" id="cbPresent_3" name="cbPresent_3" className='add-only' value="Impaired" /> Impaired
                    </td>
                </tr>
                <tr>
                    <td className='w-100'>
                        <span>Past</span>
                    </td>
                    <td className='w-100'>
                        <input type="checkbox" id="cbPast_1" name="cbPast_1" className='add-only' value="Good" /> Good
                    </td>
                    <td className='w-100'>
                        <input type="checkbox" id="cbPast_2" name="cbPast_2" className='add-only' value="Fair" /> Fair
                    </td>
                    <td className='w-450'>
                        <input type="checkbox" id="cbPast_3" name="cbPast_3" className='add-only' value="Impaired" /> Impaired
                    </td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <span><strong>Associations:</strong></span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbAssociations_1" name="cbAssociations_1" className='add-only' value="Intact" /> Intact
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbAssociations_2" name="cbAssociations_2" className='add-only' value="Loose" /> Loose
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbAssociations_3" name="cbAssociations_3" className='add-only' value="Tangential" /> Tangential
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbAssociations_4" name="cbAssociations_4" className='add-only' value="Overly Detailed" /> Overly Detailed
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbAssociations_5" name="cbAssociations_5" className='add-only' value="Coherent" /> Coherent
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbAssociations_6" name="cbAssociations_6" className='add-only' value="Circumstantial" /> Circumstantial
                    </td>
                    <td className='w-187'>&nbsp;</td>
                    <td className='w-187'>&nbsp;</td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <span><strong>Language Vocabulary:</strong></span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbLanguageVocabulary_1" name="cbLanguageVocabulary_1" className='add-only' value="Simplistic" /> Simplistic
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbLanguageVocabulary_2" name="cbLanguageVocabulary_2" className='add-only' value="Developed" /> Developed
                    </td>
                </tr>
                <tr>
                    <td colSpan={4}>
                        <span><strong>Syntax:</strong></span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="checkbox" id="cbSyntax_1" name="cbSyntax_1" className='add-only' value="Simplistic" /> Simplistic
                    </td>
                    <td className='w-187'>
                        <input type="checkbox" id="cbSyntax_2" name="cbSyntax_2" className='add-only' value="Developed" /> Developed
                    </td>
                </tr>
            </table>
            <table>
                <tr>
                    <td className='w-750'>&nbsp; </td>

                </tr>
                <tr>
                    <td className='w-750'>
                        <b>
                            <input type="checkbox" id="cbIndividualEducatedVerballyAcknowledged" name="cbIndividualEducatedVerballyAcknowledged" className='add-only' value="IndividualEducatedVerballyAcknowledged" /> Individual was educated on and verbally acknowledged the risks and benefits of the medications listed within this note via telehealth.</b>
                    </td>
                </tr>
            </table>
        </div>
    </form >
    )
}